import { b as t } from "./vendor-DWc995QB.mjs";
import { o as a } from "./overloadEither-BOCXfd9V.mjs";
import { o as s } from "./overloadMaybe-Bl7wbAkx.mjs";
const { Maybe: i, Either: m, IO: c } = t, h = (o) => s(t.Just(o)), f = (o) => s(t.Some(o)), N = () => s(t.None()), g = () => s(t.Nothing()), p = (o) => a(t.Left(o)), b = (o) => a(t.Right(o));
export {
  m as E,
  c as I,
  h as J,
  p as L,
  i as M,
  N,
  b as R,
  f as S,
  g as a
};
//# sourceMappingURL=monet-C2m13d-q.mjs.map
